/**
 * SignIn.tsx · 09_APP · OS-006
 *
 * "Logging into the OS is a badge, not a mailbox."
 * ACCESS_AND_LOGIN_DECISION_2026-08-01, decided in session. Do not reopen.
 *
 * Google sign-in, identity only. No OS passwords for anyone, ever. A
 * short-term volunteer signs in with whatever Google account she already has
 * and needs no seat, no licence and no group membership.
 */

import { signInWithGoogle } from "../lib/supabase";

export function SignIn({ problem }: { problem?: string | null }) {
  return (
    <div className="signin">
      <div className="box">
        <h1>Connect 2 Change</h1>
        <p>Communications &amp; Relationship OS</p>

        {problem ? (
          <div className="refusebox">
            <b>Not configured yet.</b>
            <div style={{ marginTop: 6 }}>{problem}</div>
            <div className="muted" style={{ marginTop: 6, fontSize: 12.5 }}>
              Copy <code>env.example</code> to <code>.env.local</code> and fill
              it in. Both values are meant to reach the browser; a service key
              never is.
            </div>
          </div>
        ) : (
          <button className="google" onClick={() => void signInWithGoogle()}>
            Sign in with Google
          </button>
        )}

        <div className="fine">
          Identity only: your name and email address. This does not give the OS
          access to your mail. C2C mail comes through one connection C2C owns,
          and what you can see is set inside the OS, not in Google.
        </div>
      </div>
    </div>
  );
}
